import { Injectable, signal } from '@angular/core'

export interface PopoverState {
  open(event?: MouseEvent | FocusEvent): void

  close(event?: MouseEvent | FocusEvent): void
}

/**
 * Keeps track of the state of the currently active popover.
 */
@Injectable({
  providedIn: 'root',
})
export class ActivePopoverStateService {
  activePopover = signal<PopoverState | undefined>(undefined)

  activate(activatingComponent: PopoverState): void {
    this.activePopover.set(activatingComponent)
  }

  deactivate(): void {
    this.activePopover.set(undefined)
  }
}
